// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // @ts-ignore
  production: ('true' === 'true'),
  // @ts-ignore
  // logger: ('{{LOGGER}}' === 'true'),
  apiEndpoint: '/api',
  openPortal: '',
  huddleFrontal: '',
  datadogClientToken: 'pub4d86813acb9d32ebe0f6b58cb239e130',
  datadogApplicationId: 'c19ea0c5-5d3d-48e7-bb13-d9b48c39179d',
  datadogService: 'open-portal-uk',
  datadogSite: 'datadoghq.eu',
  env: 'production',
  smartFlightDelay: '',
  version: "v11/v11.9/v11.9.0",
  region: "uk",
  cioDataSiteId: "{{CIO_DATA_SITE_ID}}"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
